import { ILiveMapIncidentItem } from "../../dto";

const sortIncidentsById = (
  items: readonly ILiveMapIncidentItem[],
): ILiveMapIncidentItem[] => [...items].sort((a, b) => a.id - b.id);

/** Shallow compare for live-map incident poll snapshots (skip Recoil update when unchanged). */
export const areLiveMapIncidentPollListsEqual = (
  prev: readonly ILiveMapIncidentItem[],
  next: readonly ILiveMapIncidentItem[],
): boolean => {
  if (prev === next) {
    return true;
  }

  if (prev.length !== next.length) {
    return false;
  }

  const sortedPrev = sortIncidentsById(prev);
  const sortedNext = sortIncidentsById(next);

  return sortedPrev.every((item, index) => {
    const candidate = sortedNext[index];

    return (
      item.id === candidate.id &&
      item.status === candidate.status &&
      item.rideId === candidate.rideId &&
      item.createdAt === candidate.createdAt
    );
  });
};
